import styled from "styled-components";

export const Heading = styled.h1`
  font-weight: 400;
  font-size: var(--global-font-size-l);
  margin-top: 0;
  display: flex;
`;
